import React from "react";

function UserProfile({
  imageUrl,
  size,
  firstName,
  lastName,
  useInitials,
  className,
  spacing = "mr-3",
}) {
  let imageSize;

  switch (size) {
    case "xsmall":
      imageSize = "h-6 w-6";
      break;
    case "small":
      imageSize = "h-8 w-8";
      break;
    case "medium":
      imageSize = "h-10 w-10";
      break;
    case "large":
      imageSize = "h-14 w-14";
      break;
    default:
      imageSize = "h-10 w-10";
      break;
  }

  let initials =
    useInitials && firstName && lastName ? `${firstName[0]}${lastName[0]}` : "";

  // Render the image if imageUrl is present
  if (imageUrl && imageUrl.length > 0) {
    return (
      <img
        src={imageUrl}
        alt={`${firstName} ${lastName}`}
        className={`${spacing} rounded-full object-cover bg-gray-50 inline-block align-middle ${imageSize} ${className}`}
      />
    );
  }

  // Render the initials (or bg) if imageUrl is not present
  return (
    <div
      className={`${spacing} rounded-full bg-gray-100 hover:bg-gray-300 transition-colors duration-200 inline-flex justify-center items-center text-center text-gray-700 hover:text-gray-800 w-9 h-9 text-sm font-bold uppercase ${imageSize} ${className}`}
    >
      {initials}
    </div>
  );
}

export { UserProfile };
